import React, { PropsWithChildren } from "react";
import { CodeBlock } from "@apollo/chakra-helpers";
import { CollapsibleSection } from "./CollapsibleSection";
import { outdent } from "outdent";

type ViewCodeCollapsibleProps = PropsWithChildren<{
  label: string;
  language: string;
  disableCopy?: boolean;
  code: string;
  linesToHighlight: number[];
  overrideLabel: boolean;
}>;

const generateTitle = (label: string) => {
  if (label === "response") {
    return "Show JSON response";
  } else if (!label) {
    return "Show code";
  } else {
    return `Show code for \`${label}\``;
  }
};

export function ViewCodeCollapsible({
  label = "",
  language = "",
  disableCopy,
  linesToHighlight,
  overrideLabel,
  code,
  children,
}: ViewCodeCollapsibleProps) {
  const codeString = outdent.string(code);
  // If override was applied but no label was passed, follow rules to generate title
  const titleString = overrideLabel && label ? label : generateTitle(label);
  return (
    <CollapsibleSection type="code" title={titleString}>
      <>
        {children}
        <CodeBlock
          language={language}
          disableTabs
          disableCopy={disableCopy}
          linesToHighlight={linesToHighlight}
          // Use ${outdent} to set indentation for following ${codeString}
          code={outdent`
          ${outdent}
          ${codeString}
        `}
        />
      </>
    </CollapsibleSection>
  );
}
